<template>
    <b-badge variant="warning" v-if="row.Status == 0">Yanıt Bekleniyor</b-badge>
    <b-badge variant="success" v-else-if="row.Status == 1">Kabul Edildi</b-badge>
    <b-badge variant="danger" v-else>Reddedildi</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:Object
    },

}
</script>

<style>

</style>